import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MimicUserModule } from '@features/mimic-user';
import { SharedModule } from '@shared';
import { OpenTicketsTableComponent } from './components/open-tickets-table/open-tickets-table.component';
import { PageIssuesDashboardComponent } from './components/page-issues-dashboard/page-issues-dashboard.component';
import { ProcessIssuesTableComponent } from './components/process-issues-table/process-issues-table.component';
import { IssuesDashboardDataService } from './services/issues-dashboard-data/issues-dashboard-data.service';

@NgModule({
  declarations: [PageIssuesDashboardComponent, ProcessIssuesTableComponent, OpenTicketsTableComponent],
  providers: [IssuesDashboardDataService],
  imports: [CommonModule, ReactiveFormsModule, SharedModule, MimicUserModule],
  exports: [PageIssuesDashboardComponent],
})
export class IssuesDashboardModule {}
